// export const HOME_ROUTE_LANDING = 'http://expertbunch.local:5500'
export const HOME_ROUTE_LANDING = 'https://expertbunch.com'
export const SERVICES_LANDING = '/services-expertbunch.html'
export const FREELANCER_LANDING = '/become_freelancer.html'
export const ABOUTUS_LANDING = '/about-expertbunch.html'
export const CORPORATE_SIGNUP = '/corporate-signups.html'